<template>
  <BaseModal
    @close="close"
    class="modal-message"
  >
    <div class="modal-message-container">
      <!-- <div @click="close" class="icon icon-dc_phone_icon_all_close"></div> -->
      <slot></slot>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from './BaseModal.vue'
export default {
  components: {
    BaseModal
  },
  methods: {
    close () { this.$emit('close') }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.modal-message {
  & .modal-message-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;

    background-color: var(--colorWhite);
    border-radius: var(--borderRadius1);

    & .icon {
      position: absolute;
      @media (--mediaPc) {
        right: -20px;
        top: -20px;
      }
      @media (--mediaMobile) {
        right: 10px;
        top: 10px;
      }
    }
    @media (--mediaPc) {
      height: 280px;
      width: 400px;
    }
    @media (--mediaMobile) {
      height: calc(400px / var(--scale));
      width: calc(600px / var(--scale));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/MessageModal.vue